export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13602.5dbebc35.jpg";